/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import PresetMockupColorPicker from "./PresetMockupColorPicker.vue";
import { MAX_PRINT_SIZES_GROUPED } from "../common/constants";
import HorizontalScroller from "../common/HorizontalScroller.vue";
import ShirtMockup from "./ShirtMockup.vue";
import { useDtfStore } from "../store";
import "./PresetSelector.scss";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

export default function PresetSelector({
  sizePresets = [],
  selectedPresets = ["custom"],
  disabled = false,
  index = 0,
  onSelect,
  artworkUrl: _artworkUrl,
  ...restProps
}: any) {
  const dtfStore = useDtfStore();

  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return dtfStore.artworks;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return dtfStore.isStandardArtwork;
  }

  function presetMockupColor() {
    // @ts-expect-error TS(4111): Property 'presetMockupColor' comes from an index s... Remove this comment to see the full error message
    return dtfStore.presetMockupColor;
  }

  function artwork() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return artworks()[index];
  }

  function artworkUrl() {
    return artwork().manualEditUrl || artwork().url;
  }

  function hasInvalidPresets() {
    return sizePresets.length < Object.keys(MAX_PRINT_SIZES_GROUPED).length;
  }

  function selectedColor() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return presetMockupColor()[index];
  }

  function isSelected(preset: any) {
    return selectedPresets.includes(preset);
  }

  function isLastPreset(preset: any) {
    return selectedPresets.length === 1 && selectedPresets[0] === preset;
  }

  function submitEvent(preset: any) {
    const action = isSelected(preset) ? "deselected" : "selected";
    submitDtfEvent("common_size_pressed", {
      sizeName: preset,
      action
    });
  }

  function handleSelect(e: any) {
    if (disabled) return;
    const { preset, isValid } = e.target.dataset;
    if (isLastPreset(preset) || !isValid) return;
    submitEvent(preset);
    onSelect?.({
      preset,
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      sizes: MAX_PRINT_SIZES_GROUPED[preset]
    });
    const container = e.target.closest(".preset-selector__items");
    if (container) {
      container.scrollLeft = e.target.offsetLeft;
    }
  }

  return (
    <div
      {...restProps}
      className={cn("preset-selector preset-selector--mockup scope-4c191745", restProps.className)}
      onClick={handleSelect}
      data-testid="preset-selector-mockup"
    >
      <HorizontalScroller
        className="preset-selector__items scope-4c191745"
        data-testid="preset-selector-items"
      >
        {renderList(sizePresets, sizePreset => (
          <div
            className={cn(
              "preset-selector__item scope-4c191745",
              isSelected(sizePreset.id) && "preset-selector__item--selected",
              !sizePreset.isValid && "preset-selector__item--invalid",
              isStandardArtwork() && "preset-selector__item--standard-artwork"
            )}
            key={sizePreset.id}
            data-preset={sizePreset.id}
            data-is-valid={sizePreset.isValid}
          >
            <ShirtMockup
              className="scope-4c191745"
              artworkUrl={artworkUrl()}
              preset={sizePreset.id}
              selectedColor={selectedColor()}
              data-testid="shirt-mockup"
            />
            <div className="preset-selector__title scope-4c191745">{sizePreset.title}</div>
          </div>
        ))}
      </HorizontalScroller>
      {hasInvalidPresets() ? (
        <div className="preset-selector__error-info scope-4c191745">
          {" "}
          *Some sizes are unavailable. Minimum size is 1 inch.{" "}
        </div>
      ) : null}
      <PresetMockupColorPicker
        className="scope-4c191745"
        index={index}
        data-testid="preset-mockup-color-picker"
      />
    </div>
  );
}
